import {CdMdsAnswer} from '../../../interfaces/care/cd-rai/cd-mds-answer';
import {LightUser} from '../../../interfaces/core/light-user';
import {LightUserFactory} from '../../core/light-user-factory';
import {CdMdsAnswerOption} from '../../../interfaces/care/cd-rai/cd-mds-answer-option';
import {UserService} from '../../../services/core/user.service';
import {cloneDeep} from 'lodash-es';

export class CdMdsAnswerFactory {

  /**
   *
   * @param cdMdsAnswer
   * @param cdRaiUuid
   */
  public static fromObject(cdMdsAnswer: any, cdRaiUuid: string = null): CdMdsAnswer {

    return new class implements CdMdsAnswer {
      cdMdsAnswerOptionId: number = cdMdsAnswer.c_mds_answer_option_id;
      comment: string = cdMdsAnswer.comment;
      isQuestionOk: boolean = cdMdsAnswer.is_question_ok;
      user: LightUser = cdMdsAnswer.user ? LightUserFactory.fromObject(cdMdsAnswer.user): null;
      userId: number = cdMdsAnswer.user_id;
      cdMdsQuestionId: number = cdMdsAnswer.c_mds_question ? cdMdsAnswer.c_mds_question.id : cdMdsAnswer.c_mds_answer_option ? cdMdsAnswer.c_mds_answer_option.c_mds_question_id : null;
      cdRaiUuid: string = cdRaiUuid;
      cdMdsAreaId: number = cdMdsAnswer.c_mds_question?.c_mds_area_id;

      // ------------------------------------------------------------------------------------------------
      id: number = cdMdsAnswer.id;
      deleted: 0 | 1 = 0;
      uuid: string = cdMdsAnswer.uuid;
      modified: string = cdMdsAnswer.modified;
      created: string = cdMdsAnswer.created;
    };
  }

  /**
   *
   * @param cdMdsAnswers
   * @param cdRaiUuid
   */
  public static fromArray(cdMdsAnswers: any[], cdRaiUuid: string = null): CdMdsAnswer[] {
    return cdMdsAnswers.map(_caMdsAnswer => CdMdsAnswerFactory.fromObject(_caMdsAnswer, cdRaiUuid));
  }

  /**
   *
   * @param caMdsQuestionOption
   */
  public static fromCdMdsQuestionOption(caMdsQuestionOption: CdMdsAnswerOption): CdMdsAnswer {
    return new class implements CdMdsAnswer {
      cdMdsAnswerOptionId: number = caMdsQuestionOption.id;
      comment: string = null;
      isQuestionOk: boolean = false;
      user: LightUser = UserService.getUser();
      userId: number = UserService.getUser().id;
      cdMdsQuestionId: number = caMdsQuestionOption.cdMdsQuestionId;
      cdRaiUuid: string = null;
      cdMdsAreaId: number = null;
      // ------------------------------------------------------------------------------------------------
      id: number = null;
      deleted: 0 | 1 = 0;
      uuid: string = null;
      modified: string = null;
      created: string = null;
    };
  }

  /**
   *
   * @param cdMdsAnswer
   * @param cdRaiUuid
   */
  public static copy(cdMdsAnswer: CdMdsAnswer, cdRaiUuid: string = null): CdMdsAnswer {
    const copiedCdMdsAnswer = cloneDeep(cdMdsAnswer);
    copiedCdMdsAnswer.cdRaiUuid = cdRaiUuid;

    copiedCdMdsAnswer.id = null;
    copiedCdMdsAnswer.uuid = null;
    copiedCdMdsAnswer.modified = null;
    copiedCdMdsAnswer.created = null;

    copiedCdMdsAnswer.user = UserService.getUser();
    copiedCdMdsAnswer.userId = UserService.getUser().id;
    return copiedCdMdsAnswer;
  }

  /**
   *
   * @param cdMdsAnswers
   * @param cdRaiUuid
   */
  public static copyAll(cdMdsAnswers: CdMdsAnswer[], cdRaiUuid: string = null): CdMdsAnswer[] {
    return cdMdsAnswers.map(_cdMdsAnswer => CdMdsAnswerFactory.copy(_cdMdsAnswer, cdRaiUuid));
  }

  /**
   *
   * @param cdMdsAnswer
   */
  public static toRemote(cdMdsAnswer: CdMdsAnswer): any {
    return {
      c_mds_answer_option_id: cdMdsAnswer.cdMdsAnswerOptionId,
      comment: cdMdsAnswer.comment,
      id: cdMdsAnswer.id,
      is_question_ok: cdMdsAnswer.isQuestionOk,
      modified: cdMdsAnswer.modified,
      created: cdMdsAnswer.created,
      uuid: cdMdsAnswer.uuid
    };
  }

  /**
   *
   * @param cdMdsAnswers
   */
  public static toArray(cdMdsAnswers: CdMdsAnswer[]): any[] {
    return cdMdsAnswers.map(_cdMdsAnswer => CdMdsAnswerFactory.toRemote(_cdMdsAnswer));
  }

}
